"use strict";

import { dashboardConstants } from "../_constants/dashboard.constants";

export const dashBoardGetDashboardSummaryRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_DASHBOARD_SUMMARY_REQUEST,
          payload,
     };
};

export const dashBoardGetDashboardSummaryComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_DASHBOARD_SUMMARY_COMPLETE,
          payload,
     };
};

export const dashBoardGetParticipantActivationSummaryRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_PARTICIPANT_ACTIVATION_SUMMARY_REQUEST,
          payload,
     };
};

export const dashBoardGetParticipantActivationSummaryComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_PARTICIPANT_ACTIVATION_SUMMARY_COMPLETE,
          payload,
     };
};

export const dashBoardGetRewardIssuedByCampaignRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_REWARD_ISSUED_BY_CAMPAIGN_REQUEST,
          payload,
     };
};

export const dashBoardGetRewardIssuedByCampaignComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_REWARD_ISSUED_BY_CAMPAIGN_COMPLETE,
          payload,
     };
};

export const dashBoardGetParticipantLoginSummaryRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_PARTICIPANT_LOGIN_SUMMARY_REQUEST,
          payload,
     };
};

export const dashBoardGetParticipantLoginSummaryComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_PARTICIPANT_LOGIN_SUMMARY_COMPLETE,
          payload,
     };
};

export const dashBoardGetCampaignPageViewSummaryRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_CAMPAIGN_PAGE_VIEW_SUMMARY_REQUEST,
          payload,
     };
};

export const dashBoardGetCampaignPageViewSummaryComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_CAMPAIGN_PAGE_VIEW_SUMMARY_COMPLETE,
          payload,
     };
};

export const dashBoardGetCommsPageViewSummaryRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_COMMS_PAGE_VIEW_REQUEST,
          payload,
     };
};

export const dashBoardGetCommsPageViewSummaryComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_COMMS_PAGE_VIEW_COMPLETE,
          payload,
     };
};

export const getEmailDispatchSummaryRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_EMAIL_DISPATCH_SUMMARY_REQUEST,
          payload,
     };
};

export const getEmailDispatchSummaryComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_EMAIL_DISPATCH_SUMMARY_COMPLETE,
          payload,
     };
};

export const getEmailTrackingSummaryRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_EMAIL_TRACKING_SUMMARY_REQUEST,
          payload,
     };
};

export const getEmailTrackingSummaryComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_EMAIL_TRACKING_SUMMARY_COMPLETE,
          payload,
     };
};

export const getDevicedUsedSummaryRequest = (payload) => {
     return {
          type: dashboardConstants.GET_DEVICED_USED_SUMMARY_REQUEST,
          payload,
     };
};

export const getDevicedUsedSummaryComplete = (payload) => {
     return {
          type: dashboardConstants.GET_DEVICED_USED_SUMMARY_COMPLETE,
          payload,
     };
};

export const getQ4OilMasterSummaryRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_Q4_OILMASTER_SUMMARY_REQUEST,
          payload,
     };
};

export const getQ4OilMasterSummaryComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_Q4_OILMASTER_SUMMARY_COMPLETE,
          payload,
     };
};

export const getWearTearSummaryRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_WEAR_TEER_SUMMARY_REQUEST,
          payload,
     };
};

export const getWearTearSummaryComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_WEAR_TEER_SUMMARY_COMPLETE,
          payload,
     };
};

export const getAbuDhabiSummaryRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_ABUDAHBI_SUMMARY_REQUEST,
          payload,
     };
};

export const getAbuDhabiSummaryComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_ABUDAHBI_SUMMARY_COMPLETE,
          payload,
     };
};


export const getAreaListRequest = () => {
     return {
          type: dashboardConstants.DASHBOARD_GET_AREA_LIST_REQUEST,
          
     };
};

export const getAreaListComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_GET_AREA_LIST_COMPLETE,
          payload,
     };
};

export const dashBoardGetAreaManagersLeaguesRankSummaryRequest = (payload) => {
     return {
         type: dashboardConstants.DASHBOARD_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_REQUEST,
         payload,
     };
 };
 
 export const dashBoardGetAreaManagersLeaguesRankSummaryComplete = (payload) => {
     return {
         type: dashboardConstants.DASHBOARD_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_COMPLETE,
         payload,
     };
 };

 export const dashBoardGetNotificationRequest = (payload) => {
     return {
         type: dashboardConstants.DASHBOARD_GET_NOTIFICATIONS_REQUEST,
         payload,
     };
 };
 
 export const dashBoardGetNotificationComplete = (payload) => {
     return {
         type: dashboardConstants.DASHBOARD_GET_NOTIFICATIONS_COMPLETE,
         payload,
     };
 };

 export const dashBoardDeleteNotificationRequest = (payload) => {
     return {
         type: dashboardConstants.DASHBOARD_DELETE_NOTIFICATIONS_REQUEST,
         payload,
     };
 };
 
 export const dashBoardDeleteNotificationComplete = (payload) => {
     return {
         type: dashboardConstants.DASHBOARD_DELETE_NOTIFICATIONS_COMPLETE,
         payload,
     };
 };
 


export const getRewardIssueByCampaignDispatchDownloadRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_REWARD_ISSUED_BY_DOWNLOAD_REQUEST,
          payload,
     };
};

export const getRewardIssueByCampaignDispatchDownloadComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_REWARD_ISSUED_BY_DOWNLOAD_COMPLETE,
          payload,
     };
};

export const getLoginHistorySummaryDispatchDownloadRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_USER_LOGIN_SUMMARY_DOWNLOAD_REQUEST,
          payload,
     };
};

export const getLoginHistorySummaryDispatchDownloadComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_USER_LOGIN_SUMMARY_DOWNLOAD_COMPLETE,
          payload,
     };
};

export const getEmailTrackingDispatchDownloadRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_EMAIL_TRACKING_DOWNLOAD_REQUEST,
          payload,
     };
};

export const getEmailTrackingDispatchDownloadComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_EMAIL_TRACKING_DOWNLOAD_COMPLETE,
          payload,
     };
};

export const getEmailDispatchDownloadRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_EMAIL_DISPATCH_DOWNLOAD_REQUEST,
          payload,
     };
};

export const getEmailDispatchDownloadComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_EMAIL_DISPATCH_DOWNLOAD_COMPLETE,
          payload,
     };
};

export const getCommsPageViewDispatchDownloadRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_COMMS_PAGE_VIEW_DOWNLOAD_REQUEST,
          payload,
     };
};

export const getCommsPageViewDispatchDownloadComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_COMMS_PAGE_VIEW_DOWNLOAD_COMPLETE,
          payload,
     };
};

export const getParticipantActivationSummaryDispatchDownloadRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_PARTICIPANT_ACTIVATION_DOWNLOAD_REQUEST,
          payload,
     };
};

export const getParticipantActivationSummaryDispatchDownloadComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_PARTICIPANT_ACTIVATION_DOWNLOAD_COMPLETE,
          payload,
     };
};

export const getDevicedUsedSummaryDispatchDownloadRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_DEVICED_USED_SUMMARY_DOWNLOAD_REQUEST,
          payload,
     };
};

export const getDevicedUsedSummaryDispatchDownloadComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_DEVICED_USED_SUMMARY_DOWNLOAD_COMPLETE,
          payload,
     };
};

export const getCampaignPageViewSummaryDownloadRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_CAMPAIGN_PAGE_VIEW_SUMMARY_DOWNLOAD_REQUEST,
          payload,
     };
};

export const getCampaignPageViewSummaryDownloadComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_CAMPAIGN_PAGE_VIEW_SUMMARY_DOWNLOAD_COMPLETE,
          payload,
     };
};

export const getParticipantsSliderCardDownloadRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_PARTICIPANTS_SILDERCARD_DOWNLOAD_REQUEST,
          payload,
     };
};

export const getParticipantsSliderCardDownloadComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_PARTICIPANTS_SILDERCARD_DOWNLOAD_COMPLETE,
          payload,
     };
};


export const getLocationSliderCardDownloadRequest = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_LOCATION_SILDERCARD_DOWNLOAD_REQUEST,
          payload,
     };
};

export const getLocationSliderCardDownloadComplete = (payload) => {
     return {
          type: dashboardConstants.DASHBOARD_LOCATION_SILDERCARD_DOWNLOAD_COMPLETE,
          payload,
     };
};

